import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import Footer from "../components/Footer";
import "./account.css";

export default function Account() {
  const navigate = useNavigate();

  const [admin, setAdmin] = useState(null);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  /* ================= LOAD ADMIN ================= */
  useEffect(() => {
    const loggedIn = localStorage.getItem("loggedInAdmin");
    if (!loggedIn) {
      navigate("/");
      return;
    }

    const admins = JSON.parse(localStorage.getItem("admins")) || [];
    const found = admins.find(
      a => a.email === loggedIn || a.username === loggedIn
    );

    if (!found) {
      alert("Admin not found");
      localStorage.removeItem("loggedInAdmin");
      navigate("/");
      return;
    }

    setAdmin(found);
    setName(found.username);
    setEmail(found.email);
  }, [navigate]);

  /* ================= UPDATE PROFILE ================= */
  const updateProfile = () => {
    if (!name || !email) {
      alert("All fields required");
      return;
    }

    const admins = JSON.parse(localStorage.getItem("admins")) || [];
    const index = admins.findIndex(a => a.email === admin.email);

    admins[index].username = name;
    admins[index].email = email;

    localStorage.setItem("admins", JSON.stringify(admins));
    localStorage.setItem("loggedInAdmin", email);

    setAdmin(admins[index]);
    alert("✅ Profile updated");
  };

  /* ================= UPDATE PASSWORD ================= */
  const updatePassword = () => {
    if (newPassword.length < 6) {
      alert("Password must be at least 6 characters");
      return;
    }

    if (newPassword !== confirmPassword) {
      alert("Passwords do not match");
      return;
    }

    const admins = JSON.parse(localStorage.getItem("admins")) || [];
    const index = admins.findIndex(a => a.email === admin.email);

    admins[index].password = newPassword;
    localStorage.setItem("admins", JSON.stringify(admins));

    setNewPassword("");
    setConfirmPassword("");

    alert("✅ Password updated");
  };

  if (!admin) return null;

  return (
    <div className="admin-body">
      <Topbar
        onToggleSidebar={() =>
          document.getElementById("sidebar")?.classList.toggle("open")
        }
        onToggleUserMenu={() =>
          document.getElementById("userMenu")?.classList.toggle("show")
        }
        onLogout={() => {
          localStorage.removeItem("loggedInAdmin");
          navigate("/");
        }}
      />

      <Sidebar />

      <main className="admin-main">
        <h1 className="page-title">My Account</h1>

        {/* PROFILE HERO */}
        <section className="profile-hero">
          <div className="avatar">{admin.username.charAt(0)}</div>
          <div>
            <h2>{admin.username}</h2>
            <p>{admin.email}</p>
            <span className="role-badge">Administrator</span>
          </div>
        </section>

        {/* INFO CARDS */}
        <section className="account-grid">
          <div className="account-card">
            <h3>Account Info</h3>
            <p><strong>Status:</strong> Active</p>
            <p><strong>Role:</strong> Admin</p>
            <p><strong>Security:</strong> Enabled</p>
          </div>

          <div className="account-card">
            <h3>Activity</h3>
            <p><strong>Orders:</strong> 128</p>
            <p><strong>RFQs:</strong> 16</p>
            <p><strong>Products:</strong> 54</p>
          </div>
        </section>

        {/* EDIT PROFILE */}
        <section className="table-card glass">
          <h3>Edit Profile</h3>

          <div className="form-grid">
            <div>
              <label>Full Name</label>
              <input value={name} onChange={e => setName(e.target.value)} />
            </div>

            <div>
              <label>Email</label>
              <input value={email} onChange={e => setEmail(e.target.value)} />
            </div>
          </div>

          <button className="primary big-btn" onClick={updateProfile}>
            Save Changes
          </button>
        </section>

        {/* CHANGE PASSWORD */}
        <section className="table-card glass change-password">
          <h3>Change Password</h3>

          <div className="form-grid">
            <div>
              <label>New Password</label>
              <input
                type="password"
                value={newPassword}
                onChange={e => setNewPassword(e.target.value)}
              />
            </div>

            <div>
              <label>Confirm Password</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)}
              />
            </div>
          </div>

          <button className="danger big-btn" onClick={updatePassword}>
            Update Password
          </button>
        </section>

       
      </main>
       <Footer/>
    </div>
  );
}
